import { TooltipUserGuideActionType, TooltipUserGuideEntityName, tooltipUserGuideEntityOrder } from "../actions/tooltip-user-guide";
import { AnyAction } from "redux";
import { ACCESS_CREDENTIALS_TOOLTIP, BUCKET_TOOLTIP, SHARD_CLUSTER_TOOLTIP, SHARD_REPOSITORY_TOOLTIP } from "../../constants/user-guide-tooltips";

export interface ITooltipUserGuideState {
    open: boolean;
    stepCounterEnabled: boolean;
    currentEntity?: TooltipUserGuideEntityName;
    tooltipText: {[entityName in TooltipUserGuideEntityName]: string};
}

export const TOOLTIP_USER_GUIDE_DEFAULT_STATE: ITooltipUserGuideState = {
    open: false,
    stepCounterEnabled: true,
    currentEntity: null,
    tooltipText: {
           firstStep: "", // MuTooltip incorrectly calculates offset for the first loaded tooltip in mobile viewports. This is an empty tooltip which is switched to the second one in 300 ms.
        shardRepository: SHARD_REPOSITORY_TOOLTIP,
        shardCluster: SHARD_CLUSTER_TOOLTIP,
        accessCredentials: ACCESS_CREDENTIALS_TOOLTIP,
        bucket: BUCKET_TOOLTIP,
        "storageProvider": ""
    },
}

export function tooltipUserGuide(state: ITooltipUserGuideState = TOOLTIP_USER_GUIDE_DEFAULT_STATE,
                      action: AnyAction): ITooltipUserGuideState {
    switch (action.type) {
        case TooltipUserGuideActionType.Open:
            return {
                ...state,
                open: false, // TODO RB-774
                currentEntity: tooltipUserGuideEntityOrder[0]
            };

        case TooltipUserGuideActionType.Close:
            return {
                ...state,
                open: false,
                currentEntity: null
            };

        case TooltipUserGuideActionType.EnableStepCounter:
            return {
                ...state,
                stepCounterEnabled: true,
            };

        case TooltipUserGuideActionType.DisableStepCounter:
            return {
                ...state,
                stepCounterEnabled: false,
            };

        case TooltipUserGuideActionType.NextStep: {
            let nextEntityIndex = tooltipUserGuideEntityOrder.indexOf(state.currentEntity) + 1;
            let nextEntity = state.currentEntity;

            if (nextEntityIndex < tooltipUserGuideEntityOrder.length) {
                nextEntity = tooltipUserGuideEntityOrder[nextEntityIndex];
            }

            return {
                ...state,
                currentEntity: nextEntity,
            };
        }

        case TooltipUserGuideActionType.PreviousStep: {
            let previousEntityIndex = tooltipUserGuideEntityOrder.indexOf(state.currentEntity) - 1;
            let previousEntity = state.currentEntity;

            if (previousEntityIndex >= 0) {
                previousEntity = tooltipUserGuideEntityOrder[previousEntityIndex];
            }

            return {
                ...state,
                currentEntity: previousEntity,
            };
        }

        case TooltipUserGuideActionType.SetStep: {

            return {
                ...state,
                currentEntity: action.payload.entityName,
            };
        }

        default:
            return state;

    }

}